import React from 'react';
import ControlledCarousel from './ControlledCarousel'; // Import the carousel

const Skills = () => {
  return (
    <>
      <div className="container mt-4">
        <h1>My Skills</h1>
        <ul>
          <li>try hard at many times</li>
          <li>Designing</li>
          <li>Filming</li>
          <li>Photography</li>
          <li>Playing instruments</li>
        </ul>

        {/* Add the carousel here */}
        <div className="mt-5">
          <ControlledCarousel />
        </div>
      </div>
    </>
  );
};

export default Skills;
